const MAXIMUM_MAILTIP_LENGTH = 100;

/**
 * @param message The MailTip to truncate
 * @return Truncated OOF Mailtips. Preserve words.
 */
const mailTipsOOFTruncate = (message: string) => {
    const tokens: string[] = message.split(' ');
    return tokens.reduce((acc, token) => {
        if (acc.length >= MAXIMUM_MAILTIP_LENGTH) {
            return acc;
        }
        return acc + ' ' + token;
    });
};

export default mailTipsOOFTruncate;
